import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Mail, MapPin, Phone, Send } from 'lucide-react';
export function ContactPage({
  onBack
}: {
  onBack: () => void;
}) {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const response = await fetch('https://formsubmit.co/ajax/travis.hellstrom@whiterockpartners.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          name: formState.name,
          email: formState.email,
          company: formState.company,
          message: formState.message,
          _subject: `Website Contact from ${formState.name}${formState.company ? ` at ${formState.company}` : ''}`,
          _template: 'table'
        })
      });
      const data = await response.json();
      if (data.success === 'true' || data.success === true || response.ok) {
        setSubmitted(true);
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-white pt-28 pb-20" data-id="element-164">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        {/* Back link */}
        <motion.button initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} onClick={onBack} className="flex items-center text-primary hover:text-primary-dark transition-colors mb-12 group" data-id="element-166">
          <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-167" />
          <span className="text-sm uppercase tracking-widest font-medium" data-id="element-168">
            Back to Home
          </span>
        </motion.button>

        {/* Page heading */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} data-id="element-169">
          <div className="w-16 h-1 bg-primary mb-8" data-id="element-170"></div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 uppercase tracking-tight mb-4" data-id="element-171">
            Get in Touch
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl" data-id="element-172">
            Whether you're looking to fill a critical leadership role or
            exploring your next career move, we'd love to hear from you.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-5 gap-16" data-id="element-173">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="lg:col-span-3" data-id="element-174">
            {submitted ? <div className="bg-gray-50 p-12 text-center" data-id="element-175">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-176">
                  <Send className="w-8 h-8 text-primary" data-id="element-177" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-178">
                  Message Sent
                </h3>
                <p className="text-gray-600" data-id="element-179">
                  Thank you for reaching out. We'll get back to you within one
                  business day.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-180">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-181">
                  <div data-id="element-182">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 uppercase tracking-wider mb-2" data-id="element-183">
                      Name
                    </label>
                    <input id="name" type="text" required value={formState.name} onChange={e => setFormState({
                  ...formState,
                  name: e.target.value
                })} className="w-full px-4 py-3 border border-gray-300 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors text-gray-900" placeholder="Your name" data-id="element-184" />
                  </div>
                  <div data-id="element-185">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 uppercase tracking-wider mb-2" data-id="element-186">
                      Email
                    </label>
                    <input id="email" type="email" required value={formState.email} onChange={e => setFormState({
                  ...formState,
                  email: e.target.value
                })} className="w-full px-4 py-3 border border-gray-300 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors text-gray-900" placeholder="you@company.com" data-id="element-187" />
                  </div>
                </div>
                <div data-id="element-188">
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 uppercase tracking-wider mb-2" data-id="element-189">
                    Company
                  </label>
                  <input id="company" type="text" value={formState.company} onChange={e => setFormState({
                ...formState,
                company: e.target.value
              })} className="w-full px-4 py-3 border border-gray-300 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors text-gray-900" placeholder="Your company name" data-id="element-190" />
                </div>
                <div data-id="element-191">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 uppercase tracking-wider mb-2" data-id="element-192">
                    Message
                  </label>
                  <textarea id="message" required rows={6} value={formState.message} onChange={e => setFormState({
                ...formState,
                message: e.target.value
              })} className="w-full px-4 py-3 border border-gray-300 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors text-gray-900 resize-none" placeholder="Tell us about your search needs..." data-id="element-193" />
                </div>
                <button type="submit" disabled={submitting} className="inline-flex items-center px-8 py-3 bg-primary text-white font-medium uppercase tracking-wider hover:bg-primary-dark transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-194">
                  {submitting ? 'Sending...' : 'Send Message'}
                  <Send className="ml-3 w-4 h-4" data-id="element-195" />
                </button>
                {error && <p className="text-red-600 text-sm mt-3" data-id="element-196">{error}</p>}
              </form>}
          </motion.div>

          {/* Contact Info Sidebar */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="lg:col-span-2" data-id="element-197">
            <div className="bg-gray-50 p-8 space-y-8" data-id="element-198">
              <div data-id="element-199">
                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-4" data-id="element-200">
                  Office
                </h3>
                <div className="flex items-start text-gray-700" data-id="element-201">
                  <MapPin className="w-5 h-5 mr-3 mt-1 text-primary flex-shrink-0" data-id="element-202" />
                  <span data-id="element-203">Austin, Texas</span>
                </div>
              </div>
              <div data-id="element-204">
                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-4" data-id="element-205">
                  Phone
                </h3>
                <div className="flex items-center text-gray-700" data-id="element-206">
                  <Phone className="w-5 h-5 mr-3 text-primary flex-shrink-0" data-id="element-207" />
                  <span data-id="element-208">(512) 476-1595</span>
                </div>
              </div>
              <div data-id="element-209">
                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-4" data-id="element-210">
                  Email
                </h3>
                <div className="flex items-center text-gray-700" data-id="element-211">
                  <Mail className="w-5 h-5 mr-3 text-primary flex-shrink-0" data-id="element-212" />
                  <span data-id="element-213">hello@whiterock.partners</span>
                </div>
              </div>
            </div>

            <div className="mt-8 p-8 border border-gray-200" data-id="element-214">
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-215">
                Looking for your next role?
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-216">
                We work with exceptional executives at all stages. Send us your
                background and we'll be in touch when the right opportunity
                arises.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}